// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"checkbox__wrapper-ePc3E","checkbox":"checkbox__checkbox-2cDWr","title":"checkbox__title-2nZRM","label":"checkbox__label-3VR3L"};


//////////////////
// WEBPACK FOOTER
// ./packages/account-ui/checkbox/checkbox.css
// module id = 867
// module chunks = 0